import React, { ReactElement } from 'react';

interface Props {
  className?: string;
}

function confirm({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      stroke="black"
      viewBox="0 0 32 32"
      width="32"
      height="32"
      className={className}
    >
      <path fill="none" strokeWidth="3" d="M6.667 18.667l5.333 4L24 8" />
    </svg>
  );
}

export default confirm;
